export var attributesMatchDefault = function attributesMatchDefault(node, featureToggles) {
  var overrideDefaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!featureToggles.allowAttributesMatchDefault) {
    return true;
  }

  // @ts-expect-error - node.type.attrs does not exist in nodeType type, but it does exist.
  var nodeTypeAttrs = node.type.attrs;
  if (!nodeTypeAttrs || Object.keys(nodeTypeAttrs).length === 0 && Object.keys(node.attrs).length === 0) {
    return true;
  }
  var defaultAttrs = {};
  Object.keys(nodeTypeAttrs).forEach(function (key) {
    defaultAttrs[key] = nodeTypeAttrs[key].default;
  });

  // The actual node defaults don't match the node defaults when interacting with a page
  // So we override for a correct comparison
  Object.keys(overrideDefaults).forEach(function (key) {
    defaultAttrs[key] = overrideDefaults[key];
  });

  // Compare the node attributes to the default attributes
  for (var key in node.attrs) {
    if (node.attrs[key] !== defaultAttrs[key]) {
      return false;
    }
  }
  return true;
};